import React, { useState } from "react";
import { createData } from "../../utility/managerApi";
import CancelIcon from "@mui/icons-material/Cancel";

function AddCategory({
  setIsLoading,
  setAddtab,
  fetchCategories,
  currentPage,
}) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    cat_name: "",
    short_description: "",
  });

  const handleChange = async (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("formData");
    setLoading(true);
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    const response = await createData("categories/store", formData);
    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
      setLoading(false);
    } else {
      fetchCategories(currentPage);
      setLoading(false);
      setAddtab(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon
          className="cursor-pointer"
          onClick={() => setAddtab(false)}
        />
      </div>
      <h3 className="text-2xl font-medium text-center">Add New Category</h3>
      <form
        onSubmit={handleSubmit}
        className="py-12  flex flex-col justify-center items-center gap-6 "
      >
        <div className="flex flex-col gap-6 ">
          <div className="flex flex-col">
            <label htmlFor="">Category</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Category Name"
              type="text "
              name="cat_name"
              // id="email"
              value={formData.cat_name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Short Description</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[400px]"
              placeholder="Short Description"
              type="text"
              name="short_description"
              value={formData.short_description}
              onChange={handleChange}
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500"
        >
          {loading ? "Submitting.." : "Submit"}
        </button>
      </form>
    </div>
  );
}

export default AddCategory;
